import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Avatar,
  Typography,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";
import {
  Menu as MenuIcon,
  LoginRounded,
  LogoutRounded
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
const Header = ({ collapsed, setCollapsed }) => {
  const { isAuthenticated, logout,user } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar className="header-topbar" position="static" color="primary" elevation={0}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton className="toggle-icon" onClick={() => setCollapsed(!collapsed)}>
            <MenuIcon />
          </IconButton>
        </Box>
        {isAuthenticated ? (
          <>
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ mr: 2, cursor: "pointer" }}
              onClick={handleClick}
            >
              <Avatar
                alt={"user.name"}
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9pr9imIxIYtkasLO5K0XShV1ipYLS3WKYgyLtWk7jwKobonk0OrZFqe850gAsLa56Bw&usqp=CAU"
                sx={{
                  width: 32,
                  height: 32,
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "ButtonShadow",
                  },
                }}
              />
              <Typography variant="body1">{user?.name}</Typography>
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              // PaperProps={{
              //   sx: {
              //     mt: 1.5,
              //     p: 1,
              //     borderRadius: 2,
              //     boxShadow: 3,
              //     minWidth: 200,
              //     backgroundColor: "#f9f9f9",
              //   },
              // }}
            >
              <Box sx={{ px: 1.5, py: 1 }}>
                <Typography fontWeight="bold">{user?.name}</Typography>
              </Box>
              <Divider />
              <Divider />
              <MenuItem
                onClick={() => {
                  logout();
                }}
              >
                Logout <LogoutRounded sx={{ ml: 2 }} />{" "}
              </MenuItem>
            </Menu>
          </>
        ) : (
          <Box
            sx={{
              padding: 2,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link
              to="/login"
              sx={{
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                fontWeight: "bold",
                "&:hover": {
                  textDecoration: "underline",
                  color: "#e0e0e0",
                },
              }}
            >
              Login <LoginRounded sx={{ ml: 0.5, color: "inherit" }} />
            </Link>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
